import { Radio } from '~/types/Radio';
import { authenticationService } from './authentication-service';
import { RadioRelease } from '~/types/SoftwareReleases';

export const radioService = {
    getRadios,
    getRadioReleases,
    updateradioRelease
};

async function getRadios() {
    const requestBody = { "filter": {} }
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'accept': 'application/json',
            'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
        },
        body: JSON.stringify(requestBody)
    };

    const res = await fetch(`/api/v1/saas/radios/query`, requestOptions);
    const result = await res.json();
    return result.data as Radio[]

}
async function getRadioReleases(payload ?: { filter: { tenantId?: string } }) {
    const requestBody = { "filter": payload?.filter || {} }

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'accept': 'application/json',
            'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
        },
        body: JSON.stringify(requestBody)
    };

    const res = await fetch(`/api/v1/saas/radios/releases/query`, requestOptions);
    const result = await res.json();
    return result.data as RadioRelease[]
}

function updateradioRelease(payload: {
    id: string | undefined;
    release: string | undefined;
    releaseNotes: string;
    unsupported: boolean;
    isDefault: boolean;
}) {

    const requestOptions = {
        method: 'put',
        headers: {
            'Content-Type': 'application/json',
            'accept': 'application/json',
            'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
        },
        body: JSON.stringify(payload)
    };

    return fetch(`/api/v1/saas/radios/releases/${payload.id}`, requestOptions);
}